/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxDropDownListComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdropdownlist';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcDropDownListComponent),
    multi: true
};

/**
 * Drop Down List
 */

export class NgcDropDownListComponent extends ControlComponent {
     autoOpen: any;
     autoDropDownHeight: any;
     animationType: any;
     checkboxes: any;
     closeDelay: any;
     displayMember: any;
     dropDownHorizontalAlignment: any;
     dropDownVerticalAlignment: any;
     dropDownHeight: any;
     dropDownWidth: any;
     enableSelection: any;
     enableBrowserBoundsDetection: any;
     enableHover: any;
     filterable: any;
     filterHeight: any;
     filterDelay: any;
     filterPlaceHolder: any;
     incrementalSearch: any;
     incrementalSearchDelay: any;
     itemHeight: any;
     openDelay: any;
     placeHolder: any;
     popupZIndex: any;
     rtl: any;
     renderer: any;
     selectionRenderer: any;
     searchMode: any;
     scrollBarSize: any;
     source: any;
     selectedIndex: any;
     theme: any;
     template: any;
     valueMember: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Select
     * 
     * @param Event
     */
    public listOnSelect($e) {
        this.value = $e.args.item.value;
    }

    /**
     * On Unselect
     * 
     * @param Event
     */
    public listOnUnselect($e) {
        if ($e.args.item !== null) {
            this.value = $e.args.item.value;
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-dropdownlist',
    template: `<jqxDropDownList *ngIf="visible" (onSelect)="listOnSelect($event)" (onUnselect)="listOnUnselect($event)"
                [autoOpen] = "autoOpen"
                [autoDropDownHeight] = "autoDropDownHeight"
                [animationType] = "animationType"
                [checkboxes] = "checkboxes"
                [closeDelay] = "closeDelay"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropDownHorizontalAlignment] = "dropDownHorizontalAlignment"
                [dropDownVerticalAlignment] = "dropDownVerticalAlignment"
                [dropDownHeight] = "dropDownHeight"
                [dropDownWidth] = "dropDownWidth"
                [enableSelection] = "enableSelection"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [enableHover] = "enableHover"
                [filterable] = "filterable"
                [filterHeight] = "filterHeight"
                [filterDelay] = "filterDelay"
                [filterPlaceHolder] = "filterPlaceHolder"
                [incrementalSearch] = "incrementalSearch"
                [incrementalSearchDelay] = "incrementalSearchDelay"
                [itemHeight] = "itemHeight"
                [openDelay] = "openDelay"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [rtl] = "rtl"
                [renderer] = "renderer"
                [selectionRenderer] = "selectionRenderer"
                [searchMode] = "searchMode"
                [scrollBarSize] = "scrollBarSize"
                [source] = "source"
                [selectedIndex] = "selectedIndex"
                [theme] = "theme"
                [template] = "template"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                </jqxDropDownList>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'autoOpen': [{ type: Input, args: ['autoOpen', ] },],
'autoDropDownHeight': [{ type: Input, args: ['autoDropDownHeight', ] },],
'animationType': [{ type: Input, args: ['animationType', ] },],
'checkboxes': [{ type: Input, args: ['checkboxes', ] },],
'closeDelay': [{ type: Input, args: ['closeDelay', ] },],
'displayMember': [{ type: Input, args: ['displayMember', ] },],
'dropDownHorizontalAlignment': [{ type: Input, args: ['dropDownHorizontalAlignment', ] },],
'dropDownVerticalAlignment': [{ type: Input, args: ['dropDownVerticalAlignment', ] },],
'dropDownHeight': [{ type: Input, args: ['dropDownHeight', ] },],
'dropDownWidth': [{ type: Input, args: ['dropDownWidth', ] },],
'enableSelection': [{ type: Input, args: ['enableSelection', ] },],
'enableBrowserBoundsDetection': [{ type: Input, args: ['enableBrowserBoundsDetection', ] },],
'enableHover': [{ type: Input, args: ['enableHover', ] },],
'filterable': [{ type: Input, args: ['filterable', ] },],
'filterHeight': [{ type: Input, args: ['filterHeight', ] },],
'filterDelay': [{ type: Input, args: ['filterDelay', ] },],
'filterPlaceHolder': [{ type: Input, args: ['filterPlaceHolder', ] },],
'incrementalSearch': [{ type: Input, args: ['incrementalSearch', ] },],
'incrementalSearchDelay': [{ type: Input, args: ['incrementalSearchDelay', ] },],
'itemHeight': [{ type: Input, args: ['itemHeight', ] },],
'openDelay': [{ type: Input, args: ['openDelay', ] },],
'placeHolder': [{ type: Input, args: ['placeHolder', ] },],
'popupZIndex': [{ type: Input, args: ['popupZIndex', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'renderer': [{ type: Input, args: ['renderer', ] },],
'selectionRenderer': [{ type: Input, args: ['selectionRenderer', ] },],
'searchMode': [{ type: Input, args: ['searchMode', ] },],
'scrollBarSize': [{ type: Input, args: ['scrollBarSize', ] },],
'source': [{ type: Input, args: ['source', ] },],
'selectedIndex': [{ type: Input, args: ['selectedIndex', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'template': [{ type: Input, args: ['template', ] },],
'valueMember': [{ type: Input, args: ['valueMember', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Drop Down List Module
 */

export class NgcDropDownListModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcDropDownListComponent],
    declarations: [NgcDropDownListComponent, jqxDropDownListComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
